"use client";

import { useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";
import { FadeIn } from "@/app/components/FadeIn";

const AdminPanel = dynamic(() => import("../portfolio/AdminPanel"), {
  ssr: false,
});

export default function MarketHero() {
  const [tapCount, setTapCount] = useState(0);
  const [showAdmin, setShowAdmin] = useState(false);
  const tapTimer = useRef<number | null>(null);
  const [originalPrice, setOriginalPrice] = useState<string>("");

  useEffect(() => {
    return () => {
      if (tapTimer.current) {
        window.clearTimeout(tapTimer.current);
      }
    };
  }, []);

  const handleSecretTap = () => {
    setTapCount((count) => {
      const nextCount = count + 1;

      if (tapTimer.current) {
        window.clearTimeout(tapTimer.current);
      }

      tapTimer.current = window.setTimeout(() => {
        setTapCount(0);
      }, 3000);

      if (nextCount >= 8) {
        setShowAdmin(true);
        setTapCount(0);
        if (tapTimer.current) {
          window.clearTimeout(tapTimer.current);
        }
        return 0;
      }

      return nextCount;
    });
  };

  return (
    <section className="max-w-[1440px] mx-auto px-margin-mobile md:px-margin-desktop mb-16">
      <FadeIn>
        <div className="border border-outline-variant bg-surface-container-lowest rounded-2xl p-10 md:p-14">
          <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_0.8fr] gap-10 items-start">
            <div className="space-y-6">
              <p className="font-label-sm text-label-sm uppercase tracking-[0.3em] text-secondary">
                Studio Market
              </p>
              <h1
                className="font-display text-h2 md:text-display text-primary"
                onClick={handleSecretTap}
              >
                Automation Tools &amp; Utilities
              </h1>
              <p className="font-body-lg text-body-lg text-secondary max-w-2xl">
                Ready-made automation tools created by the studio for teams that
                need speed, reliability, and clean implementations.
              </p>
              <div className="flex flex-wrap gap-3">
                {[
                  "Commercial license",
                  "Instant delivery",
                  "Studio support",
                ].map((item) => (
                  <span
                    key={item}
                    className="px-3 py-1 border border-outline-variant text-[10px] uppercase tracking-[0.2em] text-secondary"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
            <div className="border border-outline-variant bg-surface p-6 rounded-xl space-y-5">
              <div>
                <p className="font-label-sm text-label-sm uppercase tracking-[0.2em] text-secondary">
                  Included with every tool
                </p>
                <h2 className="font-h3 text-h3 text-primary mt-3">
                  Ready to ship fast
                </h2>
              </div>
              <ul className="space-y-3">
                {[
                  "Source code + docs",
                  "Commercial usage rights",
                  "Implementation notes",
                  "Update access",
                ].map((item) => (
                  <li key={item} className="flex items-center gap-3">
                    <span className="material-symbols-outlined text-primary text-[18px]">
                      check_circle
                    </span>
                    <span className="text-sm text-secondary">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </FadeIn>
      {showAdmin && (
        <AdminPanel
          onClose={() => setShowAdmin(false)}
          originalPrice={originalPrice}
          setOriginalPrice={setOriginalPrice}
        />
      )}
    </section>
  );
}
